import { store } from "@/store";
// import car from "@vue/cli-service/lib/PluginAPI";

export const statStore = {
  namespaced: true,
  state: () => ({
    currentYear: new Date().getFullYear(),
    startMonth: 2, //March as `JS counts month from 0..
    startDate: "",
    totalKilometer: [],
    businessKilometer: [],
    allTrips: [],
    allExpenses: [],
    currentSeasonTrips: "",
    openingDate: new Date(new Date().getFullYear(), 2),
    closingDate: "",
    isNotDefaultCar: false
  }),
  getters: {
    carsArr: function() {
      return store.getters["car/getCarsArray"];
    },
    getStartDate: function(state) {
      let lastYear = state.currentYear - 1;
      let assumedStartDate = new Date(state.currentYear, state.startMonth);
      if (!state.startDate) {
        return new Date() < assumedStartDate
          ? new Date(lastYear, state.startMonth)
          : assumedStartDate;
      } else {
        return state.startDate;
      }
    },

    getTotalKilometer: function(state) {
      if (state.totalKilometer.length > 0) {
        return state.totalKilometer.reduce((x, y) => {
          return x + y;
        });
      }
      return 0;
    },

    getBusinessKilometer: function(state) {
      if (state.businessKilometer.length > 0) {
        return state.businessKilometer.reduce((x, y) => {
          return x + y;
        });
      }
      return 0;
    },

    getCurrentSeasonTrips(state) {
      let trips = [];
      state.allTrips.map(item => {
        if (
          new Date(item.trip_time) >= state.startDate &&
          new Date(item.trip_time) <= state.closingDate
        ) {
          trips.push(item);
        }
      });
      return trips;
    },

    getCurrentSeasonExpenses(state) {
      let expenses = [];
      let carsArr = store.getters["car/getCarsArray"];
      state.allExpenses.map(item => {
        if (carsArr[item.vehicle_pouch_id]) {
          if (
            new Date(item.purchase_time) >= state.startDate &&
            new Date(item.purchase_time) <= state.closingDate
          ) {
            expenses.push(item);
          }
        }
      });
      return expenses;
    },

    getTotalExpenseCost() {
      let costs = [];
      store.getters["stat/getCurrentSeasonExpenses"].map(item => {
        costs.push(parseInt(item.cost));
      });

      if (costs.length > 0) {
        return costs.reduce((x, y) => {
          return x + y;
        });
      }

      return 0;
    },

    getExpenses(state) {
      let expenses = [];
      state.allExpenses.map(item => {
        if (new Date(item.purchase_time) >= state.startDate) {
          expenses.push(item);
        }
      });
      return expenses;
    },

    getTotalFuelLitres() {
      let litres = [];
      store.getters["stat/getCurrentSeasonExpenses"].map(item => {
        if (item.is_fuel) {
          litres.push(parseInt(item.fuel_quantity));
        }
      });

      if (litres.length > 0) {
        return litres.reduce((x, y) => {
          return x + y;
        });
      }

      return 0;
    }
  },
  mutations: {
    calculateTotalKilometer(state) {
      let carsArr = store.getters["car/getCarsArray"];
      let distanceArr = [];
      store.getters["stat/getCurrentSeasonTrips"].map(item => {
        console.log(item);
        console.log(carsArr);
        if (carsArr[item.vehicle_pouch_id]) {
          distanceArr.push(
            parseInt(item.final_odometer) - parseInt(item.initial_odometer)
          );
        }
      });
      state.totalKilometer = distanceArr;
      store.commit("stat/calculateBusinessKilometer");
    },

    calculateBusinessKilometer(state) {
      let distanceArr = [];
      let carsArr = store.getters["car/getCarsArray"];
      store.getters["stat/getCurrentSeasonTrips"].map(item => {
        //ccalculateBusinessKilometer for all trips saved for a car
        if (carsArr[item.vehicle_pouch_id]) {
          if (item.is_business == "1") {
            distanceArr.push(
              parseInt(item.final_odometer) - parseInt(item.initial_odometer)
            );
          }
        }
      });
      state.businessKilometer = distanceArr;
    },

    //get all trips for a specific car
    getAlltrips(state, payload) {
      var carsCondition = payload[1]
        ? { $nin: store.getters["car/getUserSavedCarsPouchIdArray"] }
        : { $in: [payload[0]] };
      store.state.database
        .find({
          selector: {
            type: "trip",
            _id: { $exists: true },
            vehicle_pouch_id: carsCondition
          },
          sort: ["_id"]
        })
        .then(result => {
          state.allTrips = result.docs.reverse();
          console.log(state.allTrips);
          //get trips for this season
          store.commit("stat/calculateTotalKilometer");
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    getAllExpenses(state, payload) {
      var carsCondition = payload[1]
        ? { $nin: store.getters["car/getUserSavedCarsPouchIdArray"] }
        : { $in: [payload[0]] };
      store.state.database
        .find({
          selector: {
            type: "expense",
            _id: { $exists: true },
            status: 0,
            vehicle_pouch_id: carsCondition
          },
          sort: ["_id"]
        })
        .then(result => {
          state.allExpenses = result.docs.reverse();
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    getStartDate: function(state, year) {
      if (year) {
        state.startDate = new Date(year, state.startMonth);
        state.closingDate = new Date(year + 1, state.startMonth, 0);
      } else {
        let lastYear = state.currentYear - 1;
        let assumedStartDate = new Date(state.currentYear, state.startMonth);
        state.startDate =
          new Date() < assumedStartDate
            ? new Date(lastYear, state.startMonth)
            : assumedStartDate;
        state.closingDate = new Date(
          state.startDate.getFullYear() + 1,
          state.startDate.getMonth(),
          0
        );
      }
    }
  },
  actions: {
    getStatAction({ commit }, payload) {
      console.log(payload);
      commit("getAlltrips", payload);
      commit("getAllExpenses", payload);
    }
  }
};
